import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['fr', 'en', 'it', 'de', 'es'],
    fallbackLng: 'fr',
    resources: {}, // Content comes from Firestore, not inline
    detection: {
      order: ['path', 'querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupFromPathIndex: 0,
      lookupQuerystring: 'lng',
    },
    interpolation: {
      escapeValue: false,
    },
    debug: false,
  });

export default i18n;
